export default __webpack_public_path__ + "static/media/share-linkedin-icon.85a162f8.png";